import React from "react";
import { Box, Button, Paper, Typography } from "@mui/material";

export default function LookingAheadCard({ lookingAhead, onPlanNextWeek }) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: "22px",
        p: 2.4,
        border: "1px solid #dfe7f0",
        background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 800, color: "#13233d" }}>
        {lookingAhead?.title || "Plan next week"}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.65, color: "#6f7f95" }}>
        {lookingAhead?.body || "Pick one thing to focus on next."}
      </Typography>
      <Box sx={{ mt: 1.5 }}>
        <Button
          variant="contained"
          onClick={onPlanNextWeek}
          sx={{
            textTransform: "none",
            borderRadius: "14px",
            px: 2,
            py: 1,
            fontWeight: 700,
          }}
        >
          {lookingAhead?.cta_label || "Plan next week"}
        </Button>
      </Box>
    </Paper>
  );
}
